export const LOWERCASE_ALPHA = 'abcdefghijklmnopqrstuvwxyz';
export const UPPERCASE_ALPHA = LOWERCASE_ALPHA.toUpperCase();
export const NUMERIC = '0123456789';
export const SYMBOLS = `!@#$%^&*()_+-=|\\{}[]<>,.?/:";'~`;
export const ALPHANUMERIC = `${LOWERCASE_ALPHA}${UPPERCASE_ALPHA}${NUMERIC}`;
export const ALL = `${ALPHANUMERIC}${SYMBOLS}`;

/**
 * Generates a random string of the given length with the given alphabet (defaults to alphanumeric).
 */
export function randomString(length: number, alphabet = ALPHANUMERIC): string {
  return new Array(length)
    .fill(1)
    .map(() =>
      alphabet[Math.floor(Math.random() * alphabet.length)]
    ).join('');
}